/**
 * Render the final JSX of MenuTrigger
 *
 * Only renders children
 */ export const renderDialogTrigger_unstable = (state)=>state.children;
